import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import AboutUs from './Components/about.js';
import Contact from './Components/contact.js';
import Footer from './Components/footer.js';
import Header from './Components/header.js';
import Home from './Components/home.js';
import './style.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ServicePage from './Components/servicePage.js';
import ProjectPage from './Components/projectsPage.js';
import LawAndPolicies from './Components/lawAndPoliciesPage.js';
import ContactPage from './Components/contactPage.js';
import { useLanguage } from './context/LanguageContext.js';
import Service_Description from './Components/serviceDescription.js';
import { getRoute } from './utils/getRoute.js';
function useDocumentDirection(language) {
  useEffect(() => {
    document.body.dir = language === 'en' ? 'ltr' : 'rtl';
    document.documentElement.lang = language;
  }, [language]);
}

export default function App() {
  const { language } = useLanguage();
  useDocumentDirection(language);
  return (
    <div className="app-container">
      <Header />
      <Routes>
        {/* المسار الأساسي (لتحسين SEO) */}
        <Route path="/" element={<Home />} /> 
        
        {/* مسارات ثابتة تعتمد على getRoute */}
        <Route path={getRoute('home', language)} element={<Home />} />
        <Route path={getRoute('contact', language)} element={<ContactPage />} />
        <Route path={getRoute('service', language)} element={<ServicePage />} />
        <Route path={getRoute('about', language)} element={<AboutUs />} />
        <Route path={getRoute('projects', language)} element={<ProjectPage />} />
        <Route path={getRoute('policies', language)} element={<LawAndPolicies />} />
        
        {/* 🚨🚨 التعديل الحاسم: مسارات الخدمات الديناميكية (Slugs) 🚨🚨 */}
        
        {/* المسار الإنجليزي: /service/mobile-applications */}
        <Route path="/service/:slug" element={<Service_Description />} />
        
        {/* المسار العربي: /الخدمات/mobile-applications (إذا كنت تستخدمه في السايت ماب) */}
        {/* ملاحظة: إذا كان المسار العربي في السايت ماب هو أيضاً /service/:slug، فليست هناك حاجة لهذا المسار الثاني */}
        <Route path="/الخدمات/:slug" element={<Service_Description />} /> 
        
        {/* المسار القديم الثابت: يجب أن يبقى إذا كان تطبيقك يستخدمه للتنقل الداخلي */}
        <Route path={getRoute('serviceDescription', language)} element={<Service_Description />} />

        {/* إذا كان لديك مسار ID (مثل /ServiceDescription/1) يجب إضافته هنا */}
        {/* <Route path="/ServiceDescription/:id" element={<Service_Description />} /> */}
        
        {/* 404 Route - قم بإضافة مسار لمعالجة الأخطاء 404 */}
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
      <a
  href="https://wa.me/966557380850?text=مرحباً، أرغب في التواصل معكم بخصوص خدمات التسويق الرقمي"
  target="_blank"
  rel="noopener noreferrer"
  style={{
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    zIndex: 1000,
    backgroundColor: 'transparent', // ← خلفية شفافة
    border: '2px solid #b79851',   // ← حدود ذهبية
    color: '#b79851',              // ← لون النص ذهبي
    padding: '12px 18px',
    borderRadius: '30px',
    display: 'flex',
    alignItems: 'center',
    fontSize: '16px',
    fontWeight: 'bold',
    textDecoration: 'none',
    boxShadow: '0 4px 12px rgba(183, 152, 81, 0.2)', // ظل ناعم بلون ذهبي شفاف
    backdropFilter: 'blur(2px)',   // (اختياري) تأثير ضبابي خفيف خلف الزر لتحسين القراءة
  }}
>
  <img
    src="https://img.icons8.com/color/48/000000/whatsapp--v1.png"
    alt="WhatsApp"
    style={{ width: '24px', marginRight: '10px' }}
  />
  تواصل معنا
</a>
    </div>
  );
}